{
  "role": "http://xbrl.ssm.com.my/role/ssm/rol_ssmt-fs-mpers_2022-12-31/ssmt-fs-mpers_2022-12-31_role-720000",
  "sheetId": "NotesAccountingPolicies",
  "label": "[720000] Notes - Summary of Significant Accounting Policies",
  "description": "Disclosure on summary of material accounting policies",
  "controls": [
    {
      "qname": "ssmt:DisclosureOfSignificantAccountingPoliciesExplanatory",
      "label": "Disclosure of significant accounting policies",
      "type": "TextBlock",
      "required": true,
      "ui": {
        "control": "richtext",
        "rows": 10,
        "note": "MANDATORY: Provide comprehensive disclosure of all significant accounting policy information relevant to understanding the financial statements (MPERS 8.4(b), 8.5)"
      },
      "validators": [
        {
          "name": "required"
        }
      ],
      "error": {
        "required": "This is a mandatory field."
      }
    },
    {
      "qname": "ssmt-mpers:DescriptionOfAccountingPolicyForAmortisationExplanatory",
      "label": "Description of accounting policy for amortisation",
      "type": "TextBlock",
      "required": false,
      "ui": {
        "control": "richtext",
        "rows": 5
      }
    },
    {
      "qname": "ssmt-mpers:DescriptionOfAccountingPolicyForBiologicalAssetsExplanatory",
      "label": "Description of accounting policy for biological assets",
      "type": "TextBlock",
      "required": false,
      "ui": {
        "control": "richtext",
        "rows": 5
      }
    },
    {
      "qname": "ssmt-mpers:DescriptionOfAccountingPolicyForBorrowingCostsExplanatory",
      "label": "Description of accounting policy for borrowing costs",
      "type": "TextBlock",
      "required": false,
      "ui": {
        "control": "richtext",
        "rows": 5
      }
    },
    {
      "qname": "ssmt-mpers:DescriptionOfAccountingPolicyForBorrowingsExplanatory",
      "label": "Description of accounting policy for borrowings",
      "type": "TextBlock",
      "required": false,
      "ui": {
        "control": "richtext",
        "rows": 5
      }
    },
    {
      "qname": "ssmt-mpers:DescriptionOfAccountingPolicyForBusinessCombinationsExplanatory",
      "label": "Description of accounting policy for business combinations",
      "type": "TextBlock",
      "required": false,
      "ui": {
        "control": "richtext",
        "rows": 5
      }
    },
    {
      "qname": "ssmt-mpers:DescriptionOfAccountingPolicyForCashFlowsExplanatory",
      "label": "Description of accounting policy for cash and cash equivalents",
      "type": "TextBlock",
      "required": false,
      "ui": {
        "control": "richtext",
        "rows": 5
      }
    },
    {
      "qname": "ssmt-mpers:DescriptionOfAccountingPolicyForCollateralExplanatory",
      "label": "Description of accounting policy for collateral",
      "type": "TextBlock",
      "required": false,
      "ui": {
        "control": "richtext",
        "rows": 5
      }
    },
    {
      "qname": "ssmt-mpers:DescriptionOfAccountingPolicyForConstructionContractExplanatory",
      "label": "Description of accounting policy for construction contracts",
      "type": "TextBlock",
      "required": false,
      "ui": {
        "control": "richtext",
        "rows": 5
      }
    },
    {
      "qname": "ssmt-mpers:DescriptionOfAccountingPolicyForContingentAssetsExplanatory",
      "label": "Description of accounting policy for contingent assets",
      "type": "TextBlock",
      "required": false,
      "ui": {
        "control": "richtext",
        "rows": 5
      }
    },
    {
      "qname": "ssmt-mpers:DescriptionOfAccountingPolicyForContingentLiabilitiesExplanatory",
      "label": "Description of accounting policy for contingent liabilities",
      "type": "TextBlock",
      "required": false,
      "ui": {
        "control": "richtext",
        "rows": 5
      }
    },
    {
      "qname": "ssmt-mpers:DescriptionOfAccountingPolicyForDecommissioningRestorationAndRehabilitationProvisionsExplanatory",
      "label": "Description of accounting policy for decommissioning, restoration and rehabilitation provisions",
      "type": "TextBlock",
      "required": false,
      "ui": {
        "control": "richtext",
        "rows": 5
      }
    },
    {
      "qname": "ssmt-mpers:DescriptionOfAccountingPolicyForDeferredIncomeTaxExplanatory",
      "label": "Description of accounting policy for deferred income tax",
      "type": "TextBlock",
      "required": false,
      "ui": {
        "control": "richtext",
        "rows": 5
      }
    },
    {
      "qname": "ssmt-mpers:DescriptionOfAccountingPolicyForDepreciationExpenseExplanatory",
      "label": "Description of accounting policy for depreciation expense",
      "type": "TextBlock",
      "required": false,
      "ui": {
        "control": "richtext",
        "rows": 5
      }
    },
    {
      "qname": "ssmt-mpers:DescriptionOfAccountingPolicyForDividendsExplanatory",
      "label": "Description of accounting policy for dividend income",
      "type": "TextBlock",
      "required": false,
      "ui": {
        "control": "richtext",
        "rows": 5
      }
    },
    {
      "qname": "ssmt-mpers:DescriptionOfAccountingPolicyForEarningsPerShareExplanatory",
      "label": "Description of accounting policy for earnings per share",
      "type": "TextBlock",
      "required": false,
      "ui": {
        "control": "richtext",
        "rows": 5
      }
    },
    {
      "qname": "ssmt-mpers:DescriptionOfAccountingPolicyForEmployeeBenefitsExplanatory",
      "label": "Description of accounting policy for employee benefits",
      "type": "TextBlock",
      "required": false,
      "ui": {
        "control": "richtext",
        "rows": 5
      }
    },
    {
      "qname": "ssmt-mpers:DescriptionOfAccountingPolicyForEquityInstrumentsExplanatory",
      "label": "Description of accounting policy for equity instruments",
      "type": "TextBlock",
      "required": false,
      "ui": {
        "control": "richtext",
        "rows": 5
      }
    },
    {
      "qname": "ssmt-mpers:DescriptionOfAccountingPolicyForFeeAndCommissionIncomeAndExpenseExplanatory",
      "label": "Description of accounting policy for fee and commission income and expense",
      "type": "TextBlock",
      "required": false,
      "ui": {
        "control": "richtext",
        "rows": 5
      }
    },
    {
      "qname": "ssmt-mpers:DescriptionOfAccountingPolicyForOtherFinancialLiabilitiesExplanatory",
      "label": "Description of accounting policy for financial instruments",
      "type": "TextBlock",
      "required": false,
      "ui": {
        "control": "richtext",
        "rows": 5
      }
    },
    {
      "qname": "ssmt-mpers:DescriptionOfAccountingPolicyForForeignCurrencyTranslationExplanatory",
      "label": "Description of accounting policy for foreign currency",
      "type": "TextBlock",
      "required": false,
      "ui": {
        "control": "richtext",
        "rows": 5
      }
    },
    {
      "qname": "ssmt-mpers:DescriptionOfAccountingPolicyForFunctionalAndPresentationCurrencyExplanatory",
      "label": "Description of accounting policy for functional and presentation currency",
      "type": "TextBlock",
      "required": false,
      "ui": {
        "control": "richtext",
        "rows": 5
      }
    },
    {
      "qname": "ssmt-mpers:DescriptionOfAccountingPolicyForGoodsSoldExplanatory",
      "label": "Description of accounting policy for goods sold",
      "type": "TextBlock",
      "required": false,
      "ui": {
        "control": "richtext",
        "rows": 5
      }
    },
    {
      "qname": "ssmt-mpers:DescriptionOfAccountingPolicyForGoodwillExplanatory",
      "label": "Description of accounting policy for goodwill",
      "type": "TextBlock",
      "required": false,
      "ui": {
        "control": "richtext",
        "rows": 5
      }
    },
    {
      "qname": "ssmt-mpers:DescriptionOfAccountingPolicyForGovernmentGrantsExplanatory",
      "label": "Description of accounting policy for government grants",
      "type": "TextBlock",
      "required": false,
      "ui": {
        "control": "richtext",
        "rows": 5
      }
    },
    {
      "qname": "ssmt-mpers:DescriptionOfAccountingPolicyForImpairmentOfNonfinancialAssetsExplanatory",
      "label": "Description of accounting policy for impairment of non-financial assets",
      "type": "TextBlock",
      "required": false,
      "ui": {
        "control": "richtext",
        "rows": 5
      }
    },
    {
      "qname": "ssmt-mpers:DescriptionOfAccountingPolicyForIncomeTaxExplanatory",
      "label": "Description of accounting policy for income tax",
      "type": "TextBlock",
      "required": false,
      "ui": {
        "control": "richtext",
        "rows": 5
      }
    },
    {
      "qname": "ssmt-mpers:DescriptionOfAccountingPolicyForIntangibleAssetsOtherThanGoodwillExplanatory",
      "label": "Description of accounting policy for intangible assets",
      "type": "TextBlock",
      "required": false,
      "ui": {
        "control": "richtext",
        "rows": 5
      }
    },
    {
      "qname": "ssmt-mpers:DescriptionOfAccountingPolicyForInterestIncomeAndExpenseExplanatory",
      "label": "Description of accounting policy for interest income and expense",
      "type": "TextBlock",
      "required": false,
      "ui": {
        "control": "richtext",
        "rows": 5
      }
    },
    {
      "qname": "ifrs-smes:DescriptionOfAccountingPolicyForMeasuringInventories",
      "label": "Description of accounting policy for inventories",
      "type": "TextBlock",
      "required": false,
      "ui": {
        "control": "richtext",
        "rows": 5
      }
    },
    {
      "qname": "ifrs-smes:DescriptionOfAccountingPolicyForInvestmentInAssociates",
      "label": "Description of accounting policy for investment in associates",
      "type": "TextBlock",
      "required": false,
      "ui": {
        "control": "richtext",
        "rows": 5
      }
    },
    {
      "qname": "ssmt-mpers:DescriptionOfAccountingPolicyForInvestmentInSubsidiariesExplanatory",
      "label": "Description of accounting policy for investments in subsidiaries",
      "type": "TextBlock",
      "required": false,
      "ui": {
        "control": "richtext",
        "rows": 5
      }
    },
    {
      "qname": "ssmt-mpers:DescriptionOfAccountingPolicyForInvestmentPropertyExplanatory",
      "label": "Description of accounting policy for investment property",
      "type": "TextBlock",
      "required": false,
      "ui": {
        "control": "richtext",
        "rows": 5
      }
    },
    {
      "qname": "ifrs-smes:DescriptionOfAccountingPolicyForInvestmentsInJointVentures",
      "label": "Description of accounting policy for investments in joint ventures",
      "type": "TextBlock",
      "required": false,
      "ui": {
        "control": "richtext",
        "rows": 5
      }
    },
    {
      "qname": "ssmt-mpers:DescriptionOfAccountingPolicyForIssueExpensesExplanatory",
      "label": "Description of accounting policy for issue expenses",
      "type": "TextBlock",
      "required": false,
      "ui": {
        "control": "richtext",
        "rows": 5
      }
    },
    {
      "qname": "ssmt-mpers:DescriptionOfAccountingPolicyForLeasesExplanatory",
      "label": "Description of accounting policy for leases",
      "type": "TextBlock",
      "required": false,
      "ui": {
        "control": "richtext",
        "rows": 5
      }
    },
    {
      "qname": "ssmt-mpers:DescriptionOfAccountingPolicyForNoncurrentAssetsOrDisposalGroupsClassifiedAsHeldForSaleExplanatory",
      "label": "Description of accounting policy for non-current assets or disposal groups classified as held for sale and discontinued operations",
      "type": "TextBlock",
      "required": false,
      "ui": {
        "control": "richtext",
        "rows": 5
      }
    },
    {
      "qname": "ssmt-mpers:DescriptionOfAccountingPolicyForOnerousContractsExplanatory",
      "label": "Description of accounting policy for onerous contracts",
      "type": "TextBlock",
      "required": false,
      "ui": {
        "control": "richtext",
        "rows": 5
      }
    },
    {
      "qname": "ssmt-mpers:DescriptionOfAccountingPolicyForPreferenceShareCapitalExplanatory",
      "label": "Description of accounting policy for preference share capital",
      "type": "TextBlock",
      "required": false,
      "ui": {
        "control": "richtext",
        "rows": 5
      }
    },
    {
      "qname": "ssmt-mpers:DescriptionOfAccountingPolicyForPropertyPlantAndEquipmentExplanatory",
      "label": "Description of accounting policy for property, plant and equipment",
      "type": "TextBlock",
      "required": false,
      "ui": {
        "control": "richtext",
        "rows": 5
      }
    },
    {
      "qname": "ssmt-mpers:DescriptionOfAccountingPolicyForProvisionsExplanatory",
      "label": "Description of accounting policy for provisions",
      "type": "TextBlock",
      "required": false,
      "ui": {
        "control": "richtext",
        "rows": 5
      }
    },
    {
      "qname": "ssmt-mpers:DescriptionOfAccountingPolicyForRentalIncomeExplanatory",
      "label": "Description of accounting policy for rental income",
      "type": "TextBlock",
      "required": false,
      "ui": {
        "control": "richtext",
        "rows": 5
      }
    },
    {
      "qname": "ssmt-mpers:DescriptionOfAccountingPolicyForRestructuringExplanatory",
      "label": "Description of accounting policy for restructuring",
      "type": "TextBlock",
      "required": false,
      "ui": {
        "control": "richtext",
        "rows": 5
      }
    },
    {
      "qname": "ifrs-smes:DescriptionOfAccountingPolicyForRecognitionOfRevenue",
      "label": "Description of accounting policy for revenue and other income",
      "type": "TextBlock",
      "required": false,
      "ui": {
        "control": "richtext",
        "rows": 5
      }
    },
    {
      "qname": "ssmt-mpers:DescriptionOfAccountingPolicyForSegmentReportingExplanatory",
      "label": "Description of accounting policy for segment reporting",
      "type": "TextBlock",
      "required": false,
      "ui": {
        "control": "richtext",
        "rows": 5
      }
    },
    {
      "qname": "ssmt-mpers:DescriptionOfAccountingPolicyForStatePlansExplanatory",
      "label": "Description of accounting policy for state plans",
      "type": "TextBlock",
      "required": false,
      "ui": {
        "control": "richtext",
        "rows": 5
      }
    },
    {
      "qname": "ssmt-mpers:DescriptionOfAccountingPolicyForTransactionsWithRelatedPartiesExplanatory",
      "label": "Description of accounting policy for transactions with related parties",
      "type": "TextBlock",
      "required": false,
      "ui": {
        "control": "richtext",
        "rows": 5
      }
    },
    {
      "qname": "ssmt-mpers:DescriptionOfAccountingPolicyForWarrantiesExplanatory",
      "label": "Description of accounting policy for warranties",
      "type": "TextBlock",
      "required": false,
      "ui": {
        "control": "richtext",
        "rows": 5
      }
    },
    {
      "qname": "ssmt-mpers:DescriptionOfAccountingPolicyForOtherSignificantAccountingPoliciesRelevantToUnderstandingOfFinancialStatementsExplanatory",
      "label": "Description of other significant accounting policies relevant to understanding of financial statements",
      "type": "TextBlock",
      "required": false,
      "ui": {
        "control": "richtext",
        "rows": 5
      }
    },
    {
      "qname": "ssmt-mpers:DescriptionOfAccountingPolicyForBasisOfConsolidationExplanatory",
      "label": "Description of accounting policy for basis of consolidation",
      "type": "TextBlock",
      "required": false,
      "ui": {
        "control": "richtext",
        "rows": 5
      }
    },
    {
      "qname": "ssmt-mpers:DescriptionOfAccountingPolicyForBasisOfPresentationOfFinancialStatementsExplanatory",
      "label": "Description of accounting policy for basis of preparation of financial statements",
      "type": "TextBlock",
      "required": false,
      "ui": {
        "control": "richtext",
        "rows": 5
      }
    }
  ]
}
